export const MULTI_CHOICE_FILTER_OR_SEPARATOR = '--or--';
export const multiChoiceFilterValuesFrom = value => {
  if (value === null || value === undefined) return [];
  return value.toString().split(MULTI_CHOICE_FILTER_OR_SEPARATOR).filter(filterValue => filterValue.trim() !== '');
};
export const serializeMultiChoiceFilterValues = values => (values || []).filter(filterValue => filterValue !== null && filterValue !== undefined && filterValue.toString().trim() !== '').map(filterValue => filterValue.toString()).join(MULTI_CHOICE_FILTER_OR_SEPARATOR);